import axios, { AxiosInstance, CancelTokenSource } from "axios";
import type { CancelToken } from "axios";

import type {
  IFetchParkingArealByIdParams,
  ICreateFairMailParams,
  ICreatePayBackParams,
  IFetchCommentsOfParkingArealParams,
  IFetchPublicSearchParams,
} from "./domain";
import { URL as BaseURL } from "../RequestOption";

const URLS = {
  parkingAreal: "/parkingAreal",
  parkingArealSearch: "/parkingArealSearch",
  mail: "/fair/mail",
  payBack: "/payback",
};

export class PublicApiService {
  readonly http: AxiosInstance;

  constructor() {
    this.http = axios.create({
      baseURL: `${BaseURL}/api/public`,
    });
  }

  createCancellableRequest<TData>(
    requestCreator: (cancelToken: CancelTokenSource["token"]) => Promise<TData> | TData
  ): Promise<TData> | TData {
    const cancelTokenSource = axios.CancelToken.source();

    return requestCreator(cancelTokenSource.token);
  }

  async getPublicSearch(params: IFetchPublicSearchParams, cancelToken?: CancelToken) {
    const { data } = await this.http.get(URLS.parkingArealSearch, { params, cancelToken });

    return data;
  }

  async getParkingArealById(params: IFetchParkingArealByIdParams, cancelToken?: CancelToken) {
    const filter = params.id ? "?id=" + params.id : "";
    const { data } = await this.http.get(URLS.parkingAreal + filter, { cancelToken });

    return data;
  }

  async fairMail(params: ICreateFairMailParams, cancelToken?: CancelToken) {
    const filter = params.name && params.email ? "?name=" + params.name + "&email=" + params.email : "";
    const { data } = await this.http.post(URLS.mail + filter, { cancelToken });

    return data;
  }

  async payBack(params: ICreatePayBackParams, cancelToken?: CancelToken) {
    const filter =
      params.orderid && params.payerid ? "?orderid=" + params.orderid + "&payerid=" + params.payerid : "";
    const { data } = await this.http.post(URLS.payBack + filter, { cancelToken });

    return data;
  }

  async getCommentsOfParkingAreal(params: IFetchCommentsOfParkingArealParams, cancelToken?: CancelToken) {
    const { data } = await this.http.get(`/parkingAreal/${params.id}/comments`, { cancelToken });

    return data;
  }
}
